import { useCallback } from 'react'

/** @param {{ handleSendMessage: Function }} handlers */
export function useConnectAppSendAction(handlers) {
  const { handleSendMessage } = handlers
  const handleConnectAppSend = useCallback(
    ({ app }) => {
      if (!app) return
      const text = `Connect ${app.title ?? ''}`.trim()
      if (!text) return
      const connectContext = {
        slug: app.slug,
        title: app.title,
        icon: app.icon,
        iconUrl: app.iconUrl,
        description: app.description,
      }
      handleSendMessage({ text, files: [], connectContext, forceNewThread: true })
    },
    [handleSendMessage],
  )
  return { handleConnectAppSend }
}
